// extracted by mini-css-extract-plugin
module.exports = {"fixedHeader":"fixedHeader___1sEPB"};